module.exports = __webpack_public_path__ + "static/img/pdf.c6744fa2.png";